import useVendorStaffTasks from './vendorStaffTasks.js'

export default function useTasksLogic(role) {
	switch (role) {
		case 'vendor-staff':
		case 'planner-staff':
			return useVendorStaffTasks()
		/* TODO:: uncomment when implementing */
		// case 'vendor':
		// 	return useVendorTasks()
		// case 'kazoo-planner':
		// 	return usePlannerTasks()
		// case 'user':
		// 	return useUserTasks()
		default:
			return null
	}
}
